import { render, staticRenderFns } from "./product-subcategories.vue?vue&type=template&id=1ee9d370"
import script from "./product-subcategories.vue?vue&type=script&lang=js"
export * from "./product-subcategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports